export default __webpack_public_path__ + "static/media/classroom.ae2632b0.png";